import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// An invite or reset link signs the person in from its `#access_token=...`
// fragment wherever it lands. When Supabase drops redirectTo — the address is
// not on the dashboard's allowlist — it lands on the Site URL instead, and the
// person ends up on the dashboard, signed in, never asked for a password.
// Moved onto /set-password before the router or supabase-js sees the URL, so
// the fragment is still there for supabase-js to turn into a session.
if (/[#&]type=(recovery|invite)(&|$)/.test(window.location.hash) && window.location.pathname !== '/set-password') {
    window.history.replaceState(null, '', `/set-password${window.location.hash}`);
}

const container = document.getElementById('root');
if (container === null) {
    throw new Error('#root not found');
}
createRoot(container).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
